export const FETCH_DESTINATION_TYPE_REQUESTED = 'FETCH_DESTINATION_TYPE_REQUESTED';
export const FETCH_DESTINATION_TYPE_SUCCEEDED = 'FETCH_DESTINATION_TYPE_SUCCEEDED';
export const UPDATED_DESTINATION_TYPE_REQUESTED = 'UPDATED_DESTINATION_TYPE_REQUESTED';

